import { render, staticRenderFns } from "./DocumentsAndAtasModal.vue?vue&type=template&id=e674a61c"
import script from "./DocumentsAndAtasModal.vue?vue&type=script&lang=js"
export * from "./DocumentsAndAtasModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports